import { DEFAULT_TRUNCATED_STRING_LENGTH } from '@abb-procure/constants';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  /**
   * Truncate a string value to a given maximum number of characters. Adds a
   * configurable string of characters if the character count is exceeded.
   */
  transform(value: string, args?: number | [number, string]): string {
    let limit: number = DEFAULT_TRUNCATED_STRING_LENGTH;
    let appendage: string = '...';

    if (typeof args === 'object' && args.length) {
      limit = args[0];
      appendage = args[1] || appendage;
    } else if (typeof args === 'number') {
      limit = args;
    }

    return value.length > limit
      ? `${value.substring(0, limit)}${appendage}`
      : value;
  }
}
